import { render, staticRenderFns } from "./AdminActivityAdjustments.vue?vue&type=template&id=6a52c3be&scoped=true"
import script from "./AdminActivityAdjustments.vue?vue&type=script&lang=js"
export * from "./AdminActivityAdjustments.vue?vue&type=script&lang=js"
import style0 from "./AdminActivityAdjustments.vue?vue&type=style&index=0&id=6a52c3be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a52c3be",
  null
  
)

export default component.exports